/**
 * Single source of truth for normalizing user-facing tags into the
 * `Calendar.tags` slug format. Imported by every consumer that needs to
 * match a display-string tag (e.g. "🏀 NBA") against Mongo-stored
 * calendar tags (e.g. "nba"):
 *
 *   - email-sender-job's `getUsers()` (canary + expand audience query)
 *   - email-sender-job's `RecommendationEngine` (per-user tag matching)
 *   - scheduled-ops's sports-marketing audience-size estimator
 *
 * Lives in shared so the normalization can never drift between apps —
 * a divergence would silently break audience matching across the
 * propose-tags → confirm → dispatch pipeline.
 */
/**
 * Normalize a user-facing tag (e.g. "⭐️ Big 12") to the Calendar.tags
 * slug format (e.g. "big-12"): strip leading emoji + variation selectors,
 * remove apostrophes, lowercase, collapse whitespace into hyphens. Calendar
 * tags (already lowercase-hyphenated) pass through unchanged.
 */
export function normalizeTag(tag) {
    return tag
        .replace(/^[\p{Emoji}\p{Emoji_Component}\uFE0F]+\s*/u, "")
        .toLowerCase()
        .replace(/[\u0027\u2019]/g, "")
        .replace(/\s+/g, "-");
}
//# sourceMappingURL=tagNormalization.js.map